import type React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import Markdown from 'react-markdown';

export const Welcome: React.FC = () => {
    const intl = useIntl();

    return (
        <div className={'row'} data-testid={'WelcomePage'}>
            <div className={'col-xs-12'}>
                <h2>
                    <FormattedMessage id={'infoDialog.about.welcome.headline'} />
                </h2>
            </div>
            <div className={'col-sm-6'}>
                <div className={'text-size-20'}>
                    <Markdown>{intl.formatMessage({ id: 'infoDialog.about.welcome.subline1' })}</Markdown>
                </div>
                <Markdown>{intl.formatMessage({ id: 'infoDialog.about.welcome.content1' })}</Markdown>
            </div>
        </div>
    );
};
